
import apiClient from '../../Services/apiClient';
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle';
import './style.css'
import { Link, useLocation } from 'react-router-dom'; // Import Link and useLocation from react-router-dom

// Menu configuration based on user roles
const menuConfig = {
    Admin: [
        // {
        //     title: 'Navigation',
        //     items: [
        //         {
        //             title: 'Dashboard',
        //             icon: 'uil-home-alt',
        //             link: '/dashboard'
        //         }
        //     ]
        // },
        {
            title: 'Services',
            items: [
                // { title: 'Calendar', icon: 'uil-calender', link: '/apps-calendar' },
                // { title: 'Attendance', icon: 'uil-calender', link: '/attendance' },
                // { title: 'Chat', icon: 'uil-comments-alt', link: '/apps-chat' },
                {
                    title: 'Credit Card',
                    icon: 'uil-atm-card',
                    submenu: [
                        // { title: 'All Credit Card Data', link: '/allcreditcarddata' },
                        // { title: 'Apply Credit Card', link: '/applycreditcard' },
                        { title: 'All Credit Card', link: '/allcreditcard' },
                        // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                    ]
                },
                // {
                //     title: 'Loan',
                //     icon: 'mdi mdi-bank',
                //     submenu: [
                //         // { title: 'All Credit Card Data', link: '/allcreditcarddata' },
                //         // { title: 'Apply Credit Card', link: '/applycreditcard' },
                //         { title: 'All Loan Application', link: '/getallloan' },
                //         // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                //     ]
                // },
                {
                    title: 'Services',
                    icon: 'mdi mdi-cash-multiple',
                    submenu: [
                        // { title: 'All Credit Card Data', link: '/allcreditcarddata' },
                        // { title: 'Apply Credit Card', link: '/applycreditcard' },
                        { title: 'Add Services', link: '/CreateServices' },
                        { title: 'All Services', link: '/allservices' },
                        { title: 'Add Service Group', link: '/service-group-manager' },
                        { title: 'Assign Service Group', link: '/assignservicegroup' },
                        // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                    ]
                },

                {
                    title: 'All Services Leads',
                    icon: 'mdi mdi-format-list-bulleted',
                    link: '/allserviceapplicationadmin' ,
                        
                    
                },


                {
                    title: 'User',
                    icon: 'uil-user',
                    submenu: [
                        { title: 'Create User', link: '/alluser' },
                        { title: 'Create Role', link: '/roles' },
                        // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                    ]
                },
                {
                    title: 'Service Request',
                    icon: 'mdi mdi-hand-coin',
                    submenu: [
                        { title: 'Service Request Data', link: '/allservicesdata' },
                        // { title: 'Create Role', link: '/roles' },
                        // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                    ]
                }
            ]
        }
    ],
    NonAdmin: [
        // {
        //     title: 'Navigation',
        //     items: [
        //         {
        //             title: 'Dashboard',
        //             icon: 'uil-home-alt',
        //             link: '/dashboard'
        //         }
        //     ]
        // },
        {
            title: 'Services',
            items: [
                // { title: 'Calendar', icon: 'uil-calender', link: '/apps-calendar' },
                // { title: 'Attendance', icon: 'uil-calender', link: '/attendance' },
                // { title: 'Chat', icon: 'uil-comments-alt', link: '/apps-chat' },
                {
                    title: 'All Services Leads',
                    icon: 'mdi mdi-format-list-bulleted',
                    link: '/allserviceapplication' ,
                        
                    
                },
                {
                    title: 'Credit Card',
                    icon: 'uil-atm-card',
                    submenu: [
                        { title: 'All Credit Card Data', link: '/allcreditcarddata' },
                        { title: 'Apply Credit Card', link: '/applycreditcard' },
                        // { title: 'All Credit Card', link: '/allcreditcard' },
                        // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                    ]
                },

                // {
                //     title: 'Loan Application',
                //     icon: 'uil-atm-card',
                //     submenu: [
                //         { title: 'Loan Application', link: '/loanApplications' },
                //         { title: 'All Loan Applications', link: '/getAgentLoans' },
                //         // { title: 'All Credit Card', link: '/allcreditcard' },
                //         // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                //     ]
                // },
                // {
                //     title: 'User',
                //     icon: 'uil-user',
                //     submenu: [
                //         { title: 'Create User', link: '/alluser' },
                //         { title: 'Create Role', link: '/roles' },
                //         // { title: 'Apply Later Credit Card', link: '/applylatercreditcard' },
                //     ]
                // }
            ]
        }
    ],

};

function Navbar() {
    const [userRole, setUserRole] = useState('Guest');
    const [expanded, setExpanded] = useState({});
    const [serviceGroups, setServiceGroups] = useState([]);
    const location = useLocation();

    useEffect(() => {
        // Simulate fetching user role from local storage or an API
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userData = JSON.parse(user);
                // If the role is "admin" (case-insensitive), use Admin; otherwise, set to NonAdmin
                if (userData.role && userData.role.toLowerCase() === 'admin') {
                    setUserRole('Admin');
                } else {
                    setUserRole('NonAdmin');
                }
            } catch (error) {
                console.error('Error parsing user from localStorage:', error);
                //setUserRole('Guest');
            }
        } else {
            //setUserRole('Guest');
        }
    }, []);

    // 🔥 Fetch Dynamic Service Groups
    useEffect(() => {

        const token = localStorage.getItem("token");

        apiClient.get('ServiceGroups', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => {
                const groups = res.data

                    .sort((a, b) => a.displayOrder - b.displayOrder);

                setServiceGroups(groups);
            })
            .catch(err => console.error(err));

    }, []);


    const toggleExpand = (menuTitle) => {
        setExpanded((prev) => ({
            ...prev,
            [menuTitle]: !prev[menuTitle]
        }));
    };

    const menuSections = menuConfig[userRole] || [];

    return (
        <div className="wrapper">
            <div className="leftside-menu">
                <Link to="/dashboard" className="logo">
                    <span className="logo-lg">
                        <img src="assets/images/logo.png" alt="logo" />
                    </span>
                    <span className="logo-sm">
                        <img src="assets/images/logo-sm.png" alt="small logo" />
                    </span>
                </Link>
                <div className="h-100" id="leftside-menu-container" data-simplebar>
                    <ul className="side-nav">
                        {menuSections.map((section, sectionIdx) => (
                            <React.Fragment key={sectionIdx}>
                                <li className="side-nav-title">{section.title}</li>
                                {section.items.map((item, itemIdx) => {
                                    const isActiveSubItem = item.submenu && item.submenu.some(subItem => subItem.link === location.pathname);
                                    const isActiveMain = item.link === location.pathname || isActiveSubItem;

                                    return (
                                        <li
                                            className={`side-nav-item ${isActiveMain ? 'active' : ''}`}
                                            key={itemIdx}
                                        >
                                            {item.submenu ? (
                                                <>
                                                    <a
                                                        href="#!"
                                                        className="side-nav-link"
                                                        onClick={() => toggleExpand(item.title)}
                                                        aria-expanded={expanded[item.title] ? 'true' : 'false'}
                                                        aria-controls={`sidebar-${item.title.replace(/\s+/g, '')}`}
                                                    >
                                                        <i className={item.icon} />
                                                        <span>{item.title}</span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <div
                                                        className={`collapse ${expanded[item.title] ? 'show' : ''}`}
                                                        id={`sidebar-${item.title.replace(/\s+/g, '')}`}
                                                    >
                                                        <ul className="side-nav-second-level">
                                                            {item.submenu.map((subItem, subIdx) => (
                                                                <li
                                                                    key={subIdx}
                                                                    className={`${subItem.link === location.pathname ? 'active' : ''
                                                                        }`}
                                                                >
                                                                    <Link to={subItem.link}>{subItem.title}</Link>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </>
                                            ) : (
                                                <Link
                                                    to={item.link}
                                                    className={`side-nav-link ${item.link === location.pathname ? 'active' : ''
                                                        }`}
                                                >
                                                    <i className={item.icon} />
                                                    <span>{item.title}</span>
                                                </Link>
                                            )}
                                        </li>
                                    );
                                })}
                            </React.Fragment>
                        ))}

                        {/* <li className="side-nav-title">Services</li> */}

                        {/* Dynamic Service Groups - Hide for Admin */}
{userRole !== "Admin" && serviceGroups.map(group => {
    const hasSubmenu = group.services && group.services.length > 0;

    const isActiveSub =
        hasSubmenu &&
        group.services.some(
            s => location.pathname === `/service/${s.slug}`
        );

    const isActiveMain =
        location.pathname === `/group/${group.id}` || isActiveSub;

    return (
        <li
            key={group.id}
            className={`side-nav-item ${isActiveMain ? 'active' : ''}`}
        >
            {hasSubmenu ? (
                <>
                    <a
                        href="#!"
                        className="side-nav-link"
                        onClick={() => toggleExpand(group.name)}
                        aria-expanded={expanded[group.name] ? "true" : "false"}
                    >
                        <i className="mdi mdi-folder-outline" />
                        <span>{group.name}</span>
                        <span className="menu-arrow"></span>
                    </a>

                    <div className={`collapse ${expanded[group.name] ? "show" : ""}`}>
                        <ul className="side-nav-second-level">
                            {group.services
                                .sort((a, b) => a.displayOrder - b.displayOrder)
                                .map(service => (
                                    <li
                                        key={service.id}
                                        className={
                                            location.pathname === `/service/${service.slug}`
                                                ? "active"
                                                : ""
                                        }
                                    >
                                        <Link to={`/service/${service.slug}`}>
                                            {service.name}
                                        </Link>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </>
            ) : (
                <Link
                    to={`/group/${group.id}`}
                    className={`side-nav-link ${isActiveMain ? 'active' : ''}`}
                >
                    <i className="mdi mdi-folder-outline" />
                    <span>{group.name}</span>
                </Link>
            )}
        </li>
    );
})}

                    </ul>
                    <div className="clearfix" />
                </div>
            </div>
        </div>
    );
}

export default Navbar;